/* Business Documents —— Custlo 门户 Documents tab 的单据请求逻辑。

   必须由 theme.liquid 全局引入，不能内联在 section 里：
   Custlo 用 innerHTML 把 /pages/documents 的内容插进门户 DOM，
   而 innerHTML 插入的 <script> 浏览器不会执行（<style> 会生效）。
   所以这里用 document 级事件委托，内容何时被插入都能接管点击。 */

(function () {
  'use strict';

  function setMsg(el, text, kind) {
    if (!el) return;
    el.textContent = text;
    el.className = 'v2docs-msg' + (kind ? ' is-' + kind : '');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.v2docs-btn') : null;
    if (!button) return;

    var card = button.closest('.v2docs-card');
    var root = button.closest('[data-v2docs]');
    if (!card || !root) return;

    event.preventDefault();
    if (button.disabled) return;

    var msg = card.querySelector('.v2docs-msg');
    var emailField = card.querySelector('[name="email"]');
    var daysField = card.querySelector('[name="days"]');
    var company = root.dataset.company;
    var throttleMs = (parseInt(root.dataset.throttle, 10) || 0) * 1000;

    setMsg(msg, '', null);

    if (!company) {
      setMsg(msg, 'Missing customer data. Please reload the page.', 'error');
      return;
    }

    if (!emailField || !emailField.value.trim() || !emailField.checkValidity()) {
      setMsg(msg, 'Please enter a valid email address.', 'error');
      if (emailField) emailField.focus();
      return;
    }

    // 每张卡片独立限流，避免连点导致后端重复发信
    var throttleKey = 'v2docsLastRequest_' + (card.dataset.key || 'default');
    var now = Date.now();
    var last = Number(localStorage.getItem(throttleKey));
    if (throttleMs && last && now - last < throttleMs) {
      var wait = Math.ceil((throttleMs - (now - last)) / 1000);
      setMsg(msg, 'Request too frequent. Please try again in ' + wait + 's.', 'info');
      return;
    }

    var payload = { email: emailField.value.trim(), company: company };
    if (daysField) payload.days = daysField.value;

    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Processing…';

    fetch(card.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        // 204 没有响应体，直接当作「未找到」，不要去解析 JSON
        if (response.status === 204) return { __empty: true };
        return response.json()
          .catch(function () { return {}; })
          .then(function (data) {
            data.__status = response.status;
            data.__ok = response.ok;
            return data;
          });
      })
      .then(function (data) {
        if (data.__empty) {
          setMsg(msg, 'No documents found for the selected period.', 'info');
          return;
        }

        var ok = card.dataset.successMode === 'status'
          ? data.__ok                    // back-order：后端不返回 success 字段
          : (data.__ok && data.success); // invoice / delivery：以 success 字段为准

        if (ok) {
          localStorage.setItem(throttleKey, String(now));
          setMsg(msg, 'Sent. It will arrive at ' + payload.email + ' shortly.', 'ok');
          return;
        }

        // 后端对「查无数据」也返回 200 + success:false，这类信息按提示展示而非报错
        var detail = data.detail || '';
        var notFound = /no .*found/i.test(detail);
        setMsg(msg, detail || 'Request failed. Please try again.', notFound ? 'info' : 'error');
      })
      .catch(function () {
        setMsg(msg, 'Could not reach the server. If you do not receive the email shortly, please try again.', 'error');
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = original;
      });
  });
})();
